module.exports = __webpack_public_path__ + "img/exchange-main-prop.7ee68dfb.png";